import {
  PropertyDetailsType,
  propertyDetailsTypes
} from '__core/shared/model/finance/PropertyDetails.enum';
import template from './propertyDetails.template.html';

export default {
  template,
  bindings: {
    ticketOwner: '<',
    property: '<',
    propertyData: '<',
    idTicket: '<'
  },
  controllerAs: '$ctrl',
  controller: class controller {
    constructor(
      $rootScope,
      $mdMedia,
      helperService,
      eventService,
      coreLogicService,
      priceFinderService,
      uiService
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentCurrency = null;
      ctrl.isReportLoading = false;
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.currentAccount = $rootScope.CurrentAccount;
        ctrl.currentCurrency = $rootScope.CurrentCurrency();
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.availablePropertyDetailsTypes = propertyDetailsTypes;
        ctrl.ticketOwner = ctrl.ticketOwner || {};
        ctrl.property = ctrl.property || {};
        ctrl.propertyData = ctrl.propertyData || {};
        ctrl.idTicket = ctrl.idTicket || '';
        ctrl.propertyId = ctrl.property?.propertyDetails?.propertyId;
        ctrl.locationId = ctrl.property?.propertyDetails?.locationId;
        ctrl.searchType = '';
        if (ctrl.ticketOwner?.isRpDataEnabled() && !ctrl.ticketOwner.isPriceFinderEnabled()) {
          ctrl.searchType = PropertyDetailsType.rp_data.name;
        }
        if (ctrl.ticketOwner.isPriceFinderEnabled() && !ctrl.ticketOwner?.isRpDataEnabled()) {
          ctrl.searchType = PropertyDetailsType.pricefinder.name;
        }
        ctrl.openPropertyDetails();
      };

      ctrl.getCountryCca2 = () =>
        !ctrl.property?.address?.country && !ctrl.property?.address?.countryCode
          ? ctrl.organizationCountry?.cca2
          : ctrl.property.address.countryCode;

      ctrl.openPropertyDetails = () => {
        if (ctrl.propertyId && _.isEmpty(ctrl.propertyData)) {
          const handler =
            ctrl.searchType === PropertyDetailsType.rp_data.name
              ? coreLogicService.rpDataPropertyDetails({
                  idOwner: ctrl.ticketOwner?.id,
                  idTicket: ctrl.idTicket,
                  property: ctrl.property,
                  propertyId: ctrl.propertyId,
                  cca2: ctrl.getCountryCca2()
                })
              : priceFinderService.propertyDetails({
                  idOwner: ctrl.ticketOwner?.id,
                  idTicket: ctrl.idTicket,
                  property: ctrl.property,
                  propertyId: ctrl.propertyId
                });

          handler.then((res) => {
            if (res?.status) {
              ctrl.propertyData = res?.data;
              ctrl.isReady = true;
            }
          });
        } else {
          ctrl.isReady = true;
        }
      };

      ctrl.hasSuburbReport = () =>
        ctrl.property?.address?.countryCode !== 'NZ' ||
        ctrl.property?.address?.country !== 'New Zealand';

      ctrl.getPdfReport = (action, reportName) => {
        ctrl.isReportLoading = true;
        uiService.toast({
          text: {
            p1: `${reportName}-${ctrl.propertyData?.propertyDetails?.address?.formatted}-Report`,
            p2: 'is being prepared',
            p3: 'please wait...'
          },
          warn: true
        });
        const handler =
          ctrl.searchType === PropertyDetailsType.rp_data.name
            ? coreLogicService.rpDataPropertyReport({
                idOwner: ctrl.ticketOwner?.id,
                idTicket: ctrl.idTicket,
                formattedAddress: ctrl.property?.address.formatted,
                propertyId: ctrl.propertyId,
                locationId: ctrl.locationId,
                cca2: ctrl.getCountryCca2(),
                action
              })
            : priceFinderService.propertyReport({
                idOwner: ctrl.ticketOwner?.id,
                idTicket: ctrl.idTicket,
                formattedAddress: ctrl.property?.address.formatted,
                propertyId: ctrl.propertyId,
                locationId: ctrl.locationId,
                action
              });

        handler.then((res) => {
          if (res?.status) {
            uiService.toast({
              text: {
                p1: `${reportName}-${ctrl.propertyData?.propertyDetails?.address?.formatted}-Report`,
                p2: 'will be available',
                p3: 'in the notes section soon'
              },
              success: true
            });
          } else {
            const alert = helperService.errorsAlert({
              errors: res?.errors || [],
              errorMessage: res?.errorMessage || '',
              title: `${
                ctrl.searchType === PropertyDetailsType.rp_data.name
                  ? `${ctrl.organizationCountry?.cca2 === 'AU' ? 'RP Data' : 'Property Guru'}`
                  : 'Pricefinder'
              }`
            });
            eventService.alertDialog({ alert });
          }
          ctrl.isReportLoading = false;
        });
      };

      ctrl.getPropertyUrl = (action) => {
        const handler =
          ctrl.searchType === PropertyDetailsType.rp_data.name
            ? coreLogicService.rpDataPropertyUrl({
                idOwner: ctrl.ticketOwner?.id,
                propertyId: ctrl.propertyId,
                cca2: ctrl.getCountryCca2(),
                action
              })
            : priceFinderService.propertyUrl({
                idOwner: ctrl.ticketOwner?.id,
                propertyId: ctrl.propertyId,
                action
              });

        handler.then((res) => {
          if (res?.status) {
            window.open(res?.url, '_blank');
          } else {
            const alert = helperService.errorsAlert({
              errors: res?.errors || [],
              errorMessage: res?.errorMessage || '',
              title: `${
                ctrl.searchType === PropertyDetailsType.rp_data.name
                  ? `${ctrl.organizationCountry?.cca2 === 'AU' ? 'RP Data' : 'Property Guru'}`
                  : 'Pricefinder'
              }`
            });
            eventService.alertDialog({ alert });
          }
        });
      };

      ctrl.toggleEventSubscribe = (eventType) => {
        if (ctrl.searchType === PropertyDetailsType.pricefinder.name) {
          priceFinderService
            .propertyEventSubscribe({
              idOwner: ctrl.ticketOwner?.id,
              propertyId: ctrl.propertyId,
              eventType
            })
            .then((res) => {
              if (res?.status) {
                ctrl.propertyData.propertyDetails.alerts = res?.alerts || [];
              } else {
                const alert = helperService.errorsAlert({
                  errors: res?.errors || [],
                  errorMessage: res?.errorMessage || '',
                  title: 'Pricefinder'
                });
                eventService.alertDialog({ alert });
              }
            });
        }
      };

      ctrl.isEventSubscribed = (eventType) =>
        _.indexOf(ctrl.propertyData?.propertyDetails?.alerts || [], eventType) > -1;

      ctrl.getEstimateColor = (isRental) => {
        let estimateColor = 'red-600';
        if (ctrl.searchType === PropertyDetailsType.rp_data.name) {
          switch (ctrl.propertyData?.propertyDetails?.estimatedSaleConfidence) {
            case 'HIGH':
              estimateColor = 'green-600';
              break;
            case 'MEDIUM_HIGH':
              estimateColor = 'green-600';
              break;
            case 'MEDIUM':
              estimateColor = 'amber-600';
              break;
            case 'MEDIUM_LOW':
              estimateColor = 'amber-600';
              break;
            default:
              break;
          }
        }
        if (ctrl.searchType === PropertyDetailsType.pricefinder.name && isRental) {
          switch (ctrl.propertyData?.propertyDetails?.estimatedRentalConfidence) {
            case 'RecentlySold':
            case 'VeryHigh':
              estimateColor = 'green-600';
              break;
            case 'High':
            case 'Medium':
              estimateColor = 'amber-600';
              break;
            default:
              break;
          }
        }
        if (ctrl.searchType === PropertyDetailsType.pricefinder.name && !isRental) {
          switch (ctrl.propertyData?.propertyDetails?.estimatedSaleConfidence) {
            case 'RecentlySold':
            case 'VeryHigh':
              estimateColor = 'green-600';
              break;
            case 'High':
            case 'Medium':
              estimateColor = 'amber-600';
              break;
            default:
              break;
          }
        }
        return estimateColor;
      };

      ctrl.getPhoto = (photo) => {
        if (photo) {
          return `data:image/png;base64,${photo}`;
        }
        return 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
      };

      ctrl.getFormattedDate = (date) =>
        date ? moment.utc(date).format($rootScope.CurrentDateFormatPrimary()) : '-';

      ctrl.getFormattedPrice = (number, showZeroPrice) => {
        if (showZeroPrice) {
          return number !== Infinity && _.isNumber(_.toNumber(number))
            ? _.toNumber(number).formatWithCurrency(ctrl.currentCurrency)
            : (0).formatWithCurrency(ctrl.currentCurrency);
        }
        return number !== Infinity && number !== 0 && _.isNumber(_.toNumber(number))
          ? _.toNumber(number).formatWithCurrency(ctrl.currentCurrency)
          : '-';
      };

      ctrl.getFormattedPercentage = (number) =>
        _.isNumber(_.toNumber(number)) ? `${number.toFixed(2)}%` : '-';

      ctrl.getLotPlan = () =>
        `${ctrl.propertyData?.propertyDetails?.titleDetails?.lot || '-'}/${
          ctrl.propertyData?.propertyDetails?.titleDetails?.plan || '-'
        }`;

      ctrl.getArea = (number) =>
        number !== Infinity && number !== 0 && _.isNumber(_.toNumber(number))
          ? `${_.toNumber(number)}sqm`
          : '-';

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
